import { exclusiveFeatured, exclusiveList } from '@/mocks/gossip';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function ExclusiveSection() {
  return (
    <section id="exclusive" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="EXCLUSIVE · 独家爆料"
          title="独家爆料 · 深扒事件背后的舆论链条"
          desc="不只搬运瓜，我们更想弄清一件事：一条爆料是如何一步步走到全网关注的位置。以下内容为编辑部观察整理，不针对任何具体当事人。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 md:gap-6">
          <article className="lg:col-span-3 rounded-lg overflow-hidden bg-background-50 border border-background-200">
            <div className="relative w-full h-56 md:h-72 overflow-hidden bg-background-200">
              <img
                src={exclusiveFeatured.image}
                alt={exclusiveFeatured.title}
                title={`${exclusiveFeatured.title} - 黑料吃瓜网`}
                className="w-full h-full object-cover object-top"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-label">
                {exclusiveFeatured.category}
              </span>
            </div>
            <div className="p-5 md:p-6">
              <h3 className="font-heading text-xl md:text-3xl text-foreground-950 leading-snug mb-3">
                {exclusiveFeatured.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed font-body mb-3">
                {exclusiveFeatured.excerpt}
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed font-body">{exclusiveFeatured.detail}</p>
              <div className="flex flex-wrap items-center gap-4 mt-5 pt-4 border-t border-background-200 text-xs text-foreground-500 font-label">
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-star-line" aria-hidden="true"></i>
                  {exclusiveFeatured.author}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {exclusiveFeatured.time}
                </span>
                <span className="flex items-center gap-1.5 text-primary-600">
                  <i className="ri-fire-line" aria-hidden="true"></i>
                  {exclusiveFeatured.heat}
                </span>
              </div>
            </div>
          </article>

          <div className="lg:col-span-2 flex flex-col gap-4 md:gap-6">
            {exclusiveList.map((item) => (
              <article
                key={item.id}
                className="rounded-lg bg-background-50 border border-background-200 p-5 hover:border-accent-400 transition-colors"
              >
                <span className="inline-flex items-center gap-1 text-[11px] md:text-xs font-label text-accent-700 bg-accent-100 px-2 py-0.5 rounded-md mb-3">
                  <i className="ri-award-line" aria-hidden="true"></i>
                  {item.category}
                </span>
                <h3 className="font-heading text-lg md:text-xl text-foreground-950 leading-snug mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed font-body line-clamp-3">{item.excerpt}</p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200 text-xs text-foreground-500 font-label">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-quill-pen-line" aria-hidden="true"></i>
                    {item.author}
                  </span>
                  <span className="flex items-center gap-1.5 text-primary-600">
                    <i className="ri-fire-line" aria-hidden="true"></i>
                    {item.heat}
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}